// extracted by mini-css-extract-plugin
export default {"container":"DropPin_container__H-YGU","content":"DropPin_content__guXlY","title":"DropPin_title__aqmWJ","coordinates":"DropPin_coordinates__scg5E","footer":"DropPin_footer__HalPl"};